import React, { useState, useEffect,  } from "react";
import Dropdown from "../../components/Dropdown/Dropdown";
import {
  BsChevronDown,
  
} from "react-icons/bs";
import { Link } from "react-router-dom";
import { Images } from "../../assets/assets";

import "react-modern-drawer/dist/index.css";
import {
  HiClipboardList,

  HiLocationMarker,
  HiMenu,
  HiOutlineCog,

  HiPlusCircle,
  HiShoppingCart,

  HiX,
} from "react-icons/hi";
import { BsPerson } from "react-icons/bs";
import { CgShoppingCart } from "react-icons/cg";
import { useCart } from "../CartContext/CartContext";
import { useAuth } from "../AuthContext/AuthContext";

import "./style.css";

import { motion, } from "framer-motion";


const announcements = ["🚛 FREE Delivery All June & July — Shop Now & Save Big!"];

interface DropdownLabelProps {
  label: string;
  icon?: React.ReactNode;
}

const DropdownLabel: React.FC<DropdownLabelProps> = ({ label, icon }) => (
  <div
    className="flex items-center gap-1 h-full 
  hover:bg-[#75A7AD] hover:text-white">
    <span>{label}</span>
    <span>{icon}</span>
  </div>
);

const Navbar = () => {
  const [toggle, setToggle] = React.useState(false);
  const [isProductOpen, setIsProductOpen] = React.useState(false);
  const [isInspireOpen, setIsInspireOpen] = React.useState(false);
  const [isGasOpen, setIsGasOpen] = React.useState(false);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (toggle) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [toggle]);


  const toggleInspireDropdown = () => {
    setIsInspireOpen((prev) => !prev);
  };

  const toggleProductDropdown = () => {
    setIsProductOpen((prev) => !prev);
  };

  const toggleGasDropdown = () => {
    setIsGasOpen((prev) => !prev);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % announcements.length);
    }, 7000);
    return () => clearInterval(interval);
  }, []);

  const toggleDrawer = () => {
    setToggle((prevState) => !prevState);
  };

  const { cart,  fetchStockForAllItems } =
    useCart();
  const { user } = useAuth();
  const totalItems = cart.reduce(
    (total, item) => total + (item?.item_quantity || 0),
    0
  );



  return (
    <div>
      <div className="promo-banner bg-[#005D6E] text-white py-2 px-4 mx-auto h-14 flex items-center justify-center overflow-hidden">
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.5 }}
          className="text-center text-base md:text-lg font-medium">
          {announcements[index]}
        </motion.div>
      </div>
      <nav
        className="navbar-fixed bg-white mt-[60px] m-10 px-10 pr-0
   rounded-full hidden md:block ">
        <div className="flex gap-1">
          <div className="">
            <div className="w-[225px]">
              <Link to="/">
                <img
                  src={Images.LogoGreen}
                  alt="logo"
                  className="w-full h-full"
                />
              </Link>
            </div>
          </div>
          <div className="flex">
            <div
              className="cursor-pointer flex items-center justify-center hover:bg-[#75A7AD] hover:text-white"
              onMouseEnter={toggleProductDropdown}
              onMouseLeave={toggleProductDropdown}>
              <Dropdown
                isShopMenu
                toggle={() => {
                  setIsInspireOpen(false);
                  setIsGasOpen(false);
                  setIsProductOpen(!isProductOpen);
                }}
                isOpen={isProductOpen}
                setIsOpen={setIsProductOpen}
                label={<DropdownLabel label="SHOP" icon={<BsChevronDown />} />}
                items={[
                  { path: "/flavours", label: "Flavours" },
                  { path: "/water-makers", label: "Sparkling Water Makers" },
                ]}
                path={""}
              />
            </div>
            <div
              className="w-auto cursor-pointer flex items-center justify-center hover:bg-[#75A7AD] hover:text-white"
              onMouseEnter={toggleInspireDropdown}
              onMouseLeave={toggleInspireDropdown}>
              <Dropdown
                toggle={() => {
                  setIsInspireOpen(!isInspireOpen);
                  setIsGasOpen(false);
                  setIsProductOpen(false);
                }}
                isOpen={isInspireOpen}
                setIsOpen={setIsInspireOpen}
                label={
                  <DropdownLabel label="INSPIRE ME" icon={<BsChevronDown />} />
                }
                items={[
                  { path: "/mixology", label: "Mixology" },
                  { path: "/why-sodastream", label: "Environment" },
                  { path: "/blog", label: "Blog" },
                ]}
                path={""}
              />
            </div>
            <div
              className="cursor-pointer flex items-center justify-center hover:bg-[#75A7AD] hover:text-white"
              onMouseEnter={toggleGasDropdown}
              onMouseLeave={toggleGasDropdown}>
              <Dropdown
                toggle={() => {
                  setIsInspireOpen(false);
                  setIsGasOpen(!isGasOpen);
                  setIsProductOpen(false);
                }}
                isOpen={isGasOpen}
                setIsOpen={setIsGasOpen}
                label={
                  <DropdownLabel label="GET GAS" icon={<BsChevronDown />} />
                }
                items={[
                  { path: "/co2-gas-cylinders", label: "C02 Gas Cylinders" },
                  { path: "/spare", label: "Spare Cylinders" },
                  { path: "/spare-cylinders", label: "Gas Refills" },
                ]}
                path={""}
              />
            </div>
          </div>
          <div className="w-[85%] flex">
            <div className="flex-grow flex items-center justify-center">
              <Link
                className="text-[14px]"
                to={"https://support-za.sodastream.com/hc/en-za"}>
                Support
              </Link>
            </div>
            <div className="flex-grow flex items-center justify-center">
              <Link className="text-[14px]" to={"/register-machine"}>
                Register your machine
              </Link>
            </div>
            <div className="flex-grow flex items-center justify-center">
              <Link className="text-[14px]" to={"/track-order"}>
                Track Order
              </Link>
            </div>

            <div className="flex-grow flex items-center justify-center">
              <Link className="text-[14px]" to={"/store-locator"}>
                Store Locator
              </Link>
            </div>
          </div>

          <div
            className="w-[15%] flex items-center justify-center bg-[#75A7AD] 
      px-6 rounded-r-full">
            <div className="flex px- items-center justify-center">
              {user ? (
                <>
                  <div className="flex pt-[20px] w-full font-bold">
                    <div className="flex-1 w-7/10  mr-4 w-1/2">
                      <Link to={"/account"}>
                        <BsPerson color="white" size={20} />
                      </Link>
                      <span className="text-white text-[11px]  font semi-bold ">
                        {user?.firstName}
                      </span>
                    </div>
                  </div>
                </>
              ) : (
                <Link to={"/signup"}>
                  <BsPerson color="white" size={22} />
                </Link>
              )}
            </div>

            <div className="flex px-5 items-center justify-between relative w-full">
              <div
                className="relative cursor-pointer"
             
               >
                <div className="flex px-5 items-center justify-center relative">
                  <Link to={"/cart"}>
                    <CgShoppingCart
                      color="white"
                      size={28}
                      onClick={fetchStockForAllItems}
                    />
                  </Link>
                  {totalItems > 0 && (
                    <div
                      className="absolute top-0 right-0 bg-red-600 text-white rounded-full h-5 w-5 
            flex items-center justify-center text-xs">
                      {totalItems}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile view code remains unchanged */}
      <div className="md:hidden fixed top-0 left-0 w-full z-50 bg-white">
        <div className="flex-col">
          {/* Mobile nav header */}
          <nav className="bg-white w-full md:hidden">
            <div className="flex w-full justify-between items-center mt-[50px]">
              {/* Menu toggle button - Left */}
              <div className="bg-[#75A7AD]">
                {toggle ? (
                  <button
                    onClick={toggleDrawer}
                    className="text-white p-5 flex justify-center items-center bg-[#75A7AD]">
                    <HiX fontSize={30} color="white" />
                  </button>
                ) : (
                  <button
                    onClick={toggleDrawer}
                    className="text-white p-5 flex justify-center items-center bg-[#75A7AD]">
                    <HiMenu fontSize={30} />
                  </button>
                )}
              </div>

              {/* Logo - Center */}
              <div className="flex-1 flex justify-center px-4">
                <div className="w-[225px]">
                  <Link to="/">
                    <img
                      src={Images.LogoGreen}
                      alt="logo"
                      className="w-full h-auto"
                    />
                  </Link>
                </div>
              </div>

              {/* Cart icon - Right */}
              <div className="bg-[#75A7AD]">
                <div className="flex p-5 items-center justify-center relative">
                  <Link to={"/cart"} className="text-white">
                    <CgShoppingCart color="white" size={25} />
                  </Link>
                  {totalItems > 0 && (
                    <div className="absolute top-3 right-1 bg-red-600 text-white rounded-full h-5 w-5 flex items-center justify-center text-xs">
                      {totalItems}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </nav>

          <div className="w-full bg-white flex pb-[10px] items-center justify-center">
            <Link
              to="/water-makers"
              className="font-semibold p-2 w-1/3 text-center">
              Machines
            </Link>
            <Link to="/spare" className="font-semibold p-2 w-1/3 text-center">
              Get Gas
            </Link>
            <Link
              to="/flavours"
              className="font-semibold p-2 w-1/3 text-center">
              Flavours
            </Link>
          </div>

          {/* Mobile menu drawer */}
          {toggle && (
            <>
              <div
                className="relative max-w-[90%] min-h-screen px-6 py-4 
              z-50 top-0 w-full">
                <div className="flex flex-col space-y-4 w-full">
                  <p className=""></p>

                  <p>
                    <Link
                      className="flex items-center text-[#75A7AD] hover:text-gray-800 text-[14px]"
                      to={"/mixology"}>
                      <HiPlusCircle className="mr-2" size={20} />
                      Mixology
                    </Link>
                  </p>

                  <p>
                    <Link
                      className="flex items-center text-[#75A7AD] hover:text-gray-800 text-[14px]"
                      to={"/accessories"}>
                      <HiShoppingCart className="mr-2" size={20} />
                      Bottles
                    </Link>
                  </p>

                  <p>
                    <Link
                      className="flex items-center text-[#75A7AD] hover:text-gray-800 text-[14px]"
                      to={"/blog"}>
                      <HiClipboardList className="mr-2" size={20} />
                      Blogs
                    </Link>
                  </p>

                  <p>
                    <Link
                      className="flex items-center text-[#75A7AD] hover:text-gray-800 text-[14px]"
                      to={"/spare-cylinders"}>
                      <HiOutlineCog className="mr-2" size={20} />
                      Spare Cylinders
                    </Link>
                  </p>

                  {/* <p>
                    <Link
                      className="flex items-center text-[#75A7AD] hover:text-gray-800 text-[14px]"
                      to={"/gas-refills"}>
                      <HiOutlineCog className="mr-2" size={20} />
                      Gas Refills
                    </Link>
                  </p> */}

                  <p>
                    <Link
                      className="flex items-center text-[#75A7AD] hover:text-gray-800 text-[14px]"
                      to={"https://support-za.sodastream.com/hc/en-za"}>
                      <HiLocationMarker className="mr-2" size={20} />
                      Support
                    </Link>
                  </p>

                  <p>
                    <Link
                      className="flex items-center text-[#75A7AD] hover:text-gray-800 text-[14px]"
                      to={"/track-order"}>
                      <HiLocationMarker className="mr-2" size={20} />
                      Track Order
                    </Link>
                  </p>

                  {user && (
                    <>
                      <p>
                        <Link
                          className="flex items-center text-[#75A7AD] hover:text-gray-800 text-[14px]"
                          to={"/account"}>
                          <HiLocationMarker className="mr-2" size={20} />
                          My Orders
                        </Link>
                      </p>

                      <p>
                        <Link
                          className="flex items-center text-[#75A7AD] hover:text-gray-800 text-[14px]"
                          to={"/account"}>
                          <HiLocationMarker className="mr-2" size={20} />
                          Personal Details
                        </Link>
                      </p>
                    </>
                  )}

                  <p>
                    <Link
                      className="flex items-center text-[#75A7AD] hover:text-gray-800 text-[14px]"
                      to={"/store-locator"}>
                      <HiLocationMarker className="mr-2" size={20} />
                      Store Locator
                    </Link>
                  </p>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
